import React, { useEffect } from 'react';
import moment from 'moment';
import { getLocalTime, getLocationText } from '../../utils/helpers';
import { AssetResourceType } from '../../interfaces';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var renderSession = function renderSession(session) {
  var _session$location, _session$location2;

  var _getLocalTime = getLocalTime(moment(session.startsAt)),
      localSessionStart = _getLocalTime.localTime;

  var sessionTime = "".concat(localSessionStart.format('dddd, MMMM DD'), " at ").concat(localSessionStart.format('h:mm A z'));
  var locationText = getLocationText(session === null || session === void 0 ? void 0 : (_session$location = session.location) === null || _session$location === void 0 ? void 0 : _session$location.fullAddress, session === null || session === void 0 ? void 0 : (_session$location2 = session.location) === null || _session$location2 === void 0 ? void 0 : _session$location2.name);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx("span", {
        className: "bold",
        children: session.name
      }), " ", sessionTime]
    }), locationText && /*#__PURE__*/_jsx("p", {
      children: locationText
    })]
  });
};

var renderAsset = function renderAsset(assetResource) {
  switch (assetResource.resourceType) {
    case AssetResourceType.SESSION:
      {
        var session = assetResource.context;
        return renderSession(session);
      }
  }
};

export var IncludedAssetSummary = function IncludedAssetSummary(_ref) {
  var fetchAsset = _ref.fetchAsset,
      includedAssets = _ref.includedAssets,
      retrievedAssets = _ref.retrievedAssets;
  useEffect(function () {
    includedAssets.forEach(function (ia) {
      fetchAsset(ia);
    });
  }, []);
  if (!(retrievedAssets !== null && retrievedAssets !== void 0 && retrievedAssets.length)) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      className: "text-base text-neutral-400 mt-4",
      children: "Included with this purchase:"
    }), retrievedAssets.map(function (ra) {
      return /*#__PURE__*/_jsx("div", {
        children: renderAsset(ra)
      }, "ia-".concat(ra.resourceId));
    })]
  });
};